module.exports = __webpack_public_path__ + "03d6e6f72a596b9daad6750d89ac8a95.jpg";